module.exports = "<div class=\"obs-map obs-commune-map\"> <leaflet sizeable-component ng-if=\"mapConfig != null\" center=viewport geojson=geojson defaults=mapConfig.options maxbounds=mapConfig.maxbounds tiles=mapConfig.tiles></leaflet> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/observatoire/ng/common/obsLeafletMap.html
// module id = 882
// module chunks = 2 11 12